<section class="hero" style="text-align: center;">
    <div class="hero-content">
        <img src="../../../assets/img/active-product/animationproduct15.jpg" alt="Oil Chillers" style="max-width: 100%; height: auto;">
    </div>
</section>

<section class="products" style="padding: 50px 0; text-align: center;">
    <div class="container">
        <h1 style="text-align: center;" class="font-weight-bold">OIL CHILLERS</h1>
        <p>Explore our wide range of industrial-grade oil chillers and compressors designed for efficiency and durability.</p>
        <div class="product-cards" style="display: flex; justify-content: space-around; flex-wrap: wrap;">
            <div class="product-card" style="width: 30%; margin: 20px;">
                <i class="fa fa-cogs" style="font-size: 40px;"></i>
                <h3>Water-Cooled Chillers</h3>
                <p>Efficient water-cooling systems for various industrial applications.</p>
            </div>
            <div class="product-card" style="width: 30%; margin: 20px;">
                <i class="fa fa-check-circle" style="font-size: 40px;"></i>
                <h3>Air-Cooled Compressors</h3>
                <p>High-performance compressors for air conditioning and other cooling needs.</p>
            </div>
            <div class="product-card" style="width: 30%; margin: 20px;">
                <i class="fas fa-envelope" style="font-size: 40px;"></i>
                <h3>Custom Solutions</h3>
                <p>Tailored products to meet your specific industry requirements.</p>
            </div>
        </div>
        <a href="mailto:rvproduction2017@gmail.com" class="btn-primary" style="display: inline-block; margin-top: 30px; padding: 10px 20px; background-color: #007bff; color: white; text-decoration: none; border-radius: 5px;">Request a Quote</a>
    </div>
</section>

<section class="contact" style="padding: 50px 0; text-align: center;">
    <div class="container">
        <h2>Contact Us</h2>
        <p>Have any questions? Reach out to us for expert advice and product inquiries.</p>
        <div class="contact-options" style="display: flex; justify-content: center; gap: 20px;">
            <a href="tel:8489359948" class="contact-btn phone-btn" style="padding: 10px 20px; background-color: #28a745; color: white; border-radius: 5px; text-decoration: none;">
                <i class="fa fa-phone" style="margin-right: 10px;"></i> Call Us
            </a>
            <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn" style="padding: 10px 20px; background-color: #007bff; color: white; border-radius: 5px; text-decoration: none;">
                <i class="fa fa-envelope" style="margin-right: 10px;"></i> Email Us
            </a>
            <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn" style="padding: 10px 20px; background-color: #25D366; color: white; border-radius: 5px; text-decoration: none;">
                <i class="fa fa-whatsapp" style="margin-right: 10px;"></i> WhatsApp
            </a>
        </div>
        <p style="margin-top: 20px;">Visit our website for more information: <a href="http://www.yourwebsite.com" target="_blank">www.yourwebsite.com</a></p>
    </div>
</section>
